module.exports = __webpack_public_path__ + "img/20180815_145911_041.bf0eef74.jpg";